import { motion } from "framer-motion";

const ROSE_IMG = "https://images.unsplash.com/photo-1700573972885-253e917e62d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxyZWQlMjByb3NlcyUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3ODU0Njg1MjR8MA&ixlib=rb-4.1.0&q=85";

const chapters = [
  { n: "01", title: "Eat", body: "Brunch bites and small plates that keep the energy easy and the table full all afternoon." },
  { n: "02", title: "Sip", body: "Signature cocktails and ice-cold pours flowing all night. Sip slow." },
  { n: "03", title: "Vibe", body: "R&B from the 90s to what's hot right now — nostalgia you can feel in your chest." },
  { n: "04", title: "Repeat", body: "One night is never enough. This is a series — the page you're on is home for every next one." },
];

const reveal = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] } }),
};

export const Manifesto = () => (
  <section id="vibe" className="relative py-24 md:py-32 bg-[#150505] overflow-hidden" data-testid="manifesto-section">
    <img src={ROSE_IMG} alt="" className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-25 pointer-events-none" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#150505] via-[#150505]/90 to-transparent" />

    <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
      <motion.div variants={reveal} custom={0} initial="hidden" whileInView="visible" viewport={{ once: true }}
        className="max-w-2xl mb-16">
        <p className="text-xs uppercase tracking-[0.35em] text-[#D4AF37] mb-6">The Manifesto</p>
        <h2 className="font-serif-display text-4xl md:text-6xl leading-[0.95] tracking-tight text-[#FDFBF7]">
          Four words. One <span className="italic text-gradient-gold">ritual.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n} variants={reveal} custom={i} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-80px" }}
            className={`group border border-white/10 bg-black/40 backdrop-blur-sm p-8 hover:-translate-y-1 hover:border-[#D4AF37]/40 transition-all duration-500 ${
              i % 2 === 0 ? "md:col-span-7" : "md:col-span-5"
            }`}
            data-testid={`manifesto-chapter-${c.n}`}>
            <div className="flex items-baseline gap-5">
              <span className="font-serif-display text-2xl text-[#8C7324]">{c.n}</span>
              <h3 className="font-serif-display text-4xl md:text-5xl text-[#FDFBF7] group-hover:text-[#D4AF37] transition-colors duration-300">{c.title}</h3>
            </div>
            <p className="mt-5 text-[#A19D94] leading-relaxed">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
